import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=5b9d477a&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"
import style0 from "./CreateForm.vue?vue&type=style&index=0&id=5b9d477a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9d477a",
  null
  
)

export default component.exports